import React from 'react';
import { pushNotify } from '../../../components/Notifications';
import { shortId, statusLabels, statusTone } from '../statuses';

export const StatusBadge: React.FC<{ status: string }> = ({ status }) => (
  <span className={`merchant-status merchant-status--${statusTone(status)}`}>{statusLabels[status] || status}</span>
);

export const LoadingState: React.FC<{ label?: string }> = ({ label = 'Загружаем данные…' }) => (
  <div className="merchant-loading" role="status"><span />{label}</div>
);

export const ErrorState: React.FC<{ onRetry: () => void; label?: string }> = ({ onRetry, label = 'Не удалось загрузить данные.' }) => (
  <div className="merchant-error-state"><p>{label}</p><button type="button" className="merchant-secondary-button" onClick={onRetry}>Повторить</button></div>
);

export const EmptyState: React.FC<{ label: string }> = ({ label }) => <div className="merchant-empty-state">{label}</div>;

export const CopyId: React.FC<{ value: string | number | null }> = ({ value }) => {
  const [copied, setCopied] = React.useState(false);
  if (value === null || value === undefined || value === '') return <>—</>;
  const text = String(value);
  const copy = async () => {
    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(text);
      } else {
        const input = document.createElement('textarea');
        input.value = text;
        input.style.position = 'fixed';
        input.style.opacity = '0';
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        input.remove();
      }
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1200);
    } catch {
      pushNotify('Не удалось скопировать идентификатор.', 'Ошибка');
    }
  };
  return <button type="button" className="merchant-id" title={text} onClick={copy}>{copied ? 'Скопировано' : shortId(text)}</button>;
};

export const PageNavigation: React.FC<{ page: number; total: number; onPage: (page: number) => void }> = ({ page, total, onPage }) => {
  if (total <= 1) return null;
  return <nav className="merchant-pagination" aria-label="Страницы">
    <button type="button" disabled={page <= 1} onClick={() => onPage(page - 1)}>Назад</button>
    <span>Страница {page} из {total}</span>
    <button type="button" disabled={page >= total} onClick={() => onPage(page + 1)}>Далее</button>
  </nav>;
};
